import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { connect } from "react-redux";
import { Toast } from "primereact/toast";
import Loader from '../../templates/Loader.js';
import { CSVLink } from "react-csv";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { DistributorReportService } from "../../services/DistributorReportService";

class DistributorReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      FromDate: new Date(new Date().getFullYear(), 0, 1),
      ToDate: new Date(),
      PageNo: 1,
      PageSize: 10,
      SearchValue: "",
      SortColumn: "TotalReceived",
      SortOrder: "DESC",
      data: [],
      summary: {},
      totalRecords: 0,
      userId: "",
    };
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchReport = this.fetchReport.bind(this);
    this.FilterData = this.FilterData.bind(this);
  }

  componentDidMount() {
    this.fetchReport();
  }

  fetchReport() {
    this.setState({ loading: true });
    const body = {
      PageNo: this.state.PageNo,
      PageSize: this.state.PageSize,
      SearchValue: this.state.SearchValue,
      SortColumn: this.state.SortColumn,
      SortOrder: this.state.SortOrder,
      FromDate: this.state.FromDate.toISOString().slice(0, 10),
      ToDate: this.state.ToDate.toISOString().slice(0, 10),
      UserId: this.state.userId,
    };
    DistributorReportService.getDistributorReport(body)
  .then(res => {

    console.log("API Response:", res);

    if (res.ResponseCode === "200") {

      this.setState({
        data: res.ResponseData || [],
        summary: res.Summary || {},
        totalRecords:
          res.ResponseData && res.ResponseData.length > 0
            ? res.ResponseData[0].TotalRecords
            : 0,
        loading: false
      });

    } else {

      this.setState({
        data: [],
        summary: {},
        totalRecords: 0,
        loading: false
      });

    }
  })
  .catch((err) => {

    console.log("ERROR:", err);

    this.setState({
      data: [],
      summary: {},
      totalRecords: 0,
      loading: false
    });

  });
  }

  handleChange(e) {
    const { name, value } = e.target ? e.target : e;
    this.setState({ [name]: value });
  }

  FilterData() {
    this.setState({ PageNo: 1 }, this.fetchReport);
  }

  onPage(event) {
    this.setState({ PageNo: event.page + 1, PageSize: event.rows }, this.fetchReport);
  }

  onSort(event) {
    const sortField = event.sortField;
    const sortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    this.setState({ SortColumn: sortField, SortOrder: sortOrder }, this.fetchReport);
  }

  render() {
    const { data, summary, loading, FromDate, ToDate, PageNo, PageSize, totalRecords } = this.state;
    return (
      <div className="datatable-filter-demo">
        <Toast ref={el => (this.toast = el)} />
        <Loader loader={loading} />
        <div className="row mb-3">
          <div className="col-md-2">
            <h4>Distributor Report</h4>
          </div>
          <div className="col-md-10">
            <div className="row text-right align-items-center">
              <div className="col-md-2">
                <Calendar
                  placeholder="From Date"
                  showIcon={true}
                  name="FromDate"
                  value={FromDate}
                  onChange={e => this.setState({ FromDate: e.value })}
                  appendTo={document.getElementById("root")}
                />
              </div>
              <div className="col-md-2">
                <Calendar
                  placeholder="To Date"
                  showIcon={true}
                  name="ToDate"
                  value={ToDate}
                  onChange={e => this.setState({ ToDate: e.value })}
                  appendTo={document.getElementById("root")}
                />
              </div>
              <div className="col-md-2">
                <InputText
                  type="search"
                  name="SearchValue"
                  value={this.state.SearchValue}
                  onChange={e => this.setState({ SearchValue: e.target.value })}
                  placeholder="Search"
                />
              </div>
              <div className="col-md-2">
                <Button label="Submit" className="p-button-primary" onClick={this.FilterData} />
              </div>
              <div className="col-md-2">
                <CSVLink
                  data={data}
                  headers={[
                    { label: "Product Name", key: "ProductName" },
                    { label: "Group Name", key: "GroupName" },
                    { label: "Batch No", key: "BatchNo" },
                    { label: "Total Received", key: "TotalReceived" },
                    { label: "Total Dispatched", key: "TotalDispatched" },
                    { label: "Remains With Distributor", key: "RemainsWithDistributor" },
                    { label: "Remains At Dealer", key: "RemainsAtDealer" },
                    { label: "Returned To Warehouse", key: "ReturnedToWarehouse" },
                    { label: "Returned By Dealer", key: "ReturnedByDealer" }
                  ]}
                  filename={"Distributor_Report.csv"}
                  target="_blank"
                >
                  <Button label="Export" className="p-button-success" />
                </CSVLink>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          {/* ================= DISTRIBUTOR SUMMARY ================= */}
{summary && Object.keys(summary).length > 0 && (
  <div
    style={{
      marginBottom: "10px",
      padding: "9px 10px",
      background: "#ffffff",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      boxShadow: "0 1px 5px rgba(0,0,0,0.03)"
    }}
  >

    {/* Header */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginBottom: "7px"
      }}
    >
      <i
        className="pi pi-chart-bar"
        style={{
          color: "#4f46e5",
          fontSize: "14px",
          marginRight: "6px"
        }}
      ></i>

      <span
        style={{
          fontSize: "13px",
          fontWeight: "700",
          color: "#374151"
        }}
      >
        Distributor Summary
      </span>

      <span
        style={{
          marginLeft: "8px",
          fontSize: "10px",
          color: "#94a3b8"
        }}
      >
        Overall Stock Movement
      </span>
    </div>

    <div className="row">

      {/* Total Received */}
      <div className="col-lg-2 col-md-4 col-sm-6 mb-1">
        <div
          style={{
            height: "58px",
            padding: "6px 8px",
            borderRadius: "7px",
            background: "#eff6ff",
            borderLeft: "3px solid #2563eb",
            display: "flex",
            alignItems: "center"
          }}
        >
          <i
            className="pi pi-download"
            style={{
              color: "#2563eb",
              fontSize: "12px",
              marginRight: "7px"
            }}
          ></i>

          <div>
            <div
              style={{
                fontSize: "9px",
                color: "#64748b",
                fontWeight: "600"
              }}
            >
              RECEIVED
            </div>

            <div
              style={{
                fontSize: "16px",
                fontWeight: "700",
                color: "#1d4ed8",
                lineHeight: "18px"
              }}
            >
              {Number(summary.GrandTotalReceived || 0).toLocaleString("en-IN")}
            </div>
          </div>
        </div>
      </div>

      {/* Total Dispatched */}
      <div className="col-lg-2 col-md-4 col-sm-6 mb-1">
        <div
          style={{
            height: "58px",
            padding: "6px 8px",
            borderRadius: "7px",
            background: "#f5f3ff",
            borderLeft: "3px solid #7c3aed",
            display: "flex",
            alignItems: "center"
          }}
        >
          <i
            className="pi pi-send"
            style={{
              color: "#7c3aed",
              fontSize: "12px",
              marginRight: "7px"
            }}
          ></i>

          <div>
            <div
              style={{
                fontSize: "9px",
                color: "#64748b",
                fontWeight: "600"
              }}
            >
              DISPATCHED
            </div>

            <div
              style={{
                fontSize: "16px",
                fontWeight: "700",
                color: "#6d28d9",
                lineHeight: "18px"
              }}
            >
              {Number(summary.GrandTotalDispatched || 0).toLocaleString("en-IN")}
            </div>
          </div>
        </div>
      </div>

      {/* With Distributor */}
      <div className="col-lg-2 col-md-4 col-sm-6 mb-1">
        <div
          style={{
            height: "58px",
            padding: "6px 8px",
            borderRadius: "7px",
            background: "#f0fdf4",
            borderLeft: "3px solid #16a34a",
            display: "flex",
            alignItems: "center"
          }}
        >
          <i
            className="pi pi-box"
            style={{
              color: "#16a34a",
              fontSize: "12px",
              marginRight: "7px"
            }}
          ></i>

          <div>
            <div
              style={{
                fontSize: "9px",
                color: "#64748b",
                fontWeight: "600"
              }}
            >
              DISTRIBUTOR
            </div>

            <div
              style={{
                fontSize: "16px",
                fontWeight: "700",
                color: "#15803d",
                lineHeight: "18px"
              }}
            >
              {Number(summary.GrandRemainsWithDistributor || 0).toLocaleString("en-IN")}
            </div>
          </div>
        </div>
      </div>

      {/* At Dealer */}
      <div className="col-lg-2 col-md-4 col-sm-6 mb-1">
        <div
          style={{
            height: "58px",
            padding: "6px 8px",
            borderRadius: "7px",
            background: "#fff7ed",
            borderLeft: "3px solid #ea580c",
            display: "flex",
            alignItems: "center"
          }}
        >
          <i
            className="pi pi-home"
            style={{
              color: "#ea580c",
              fontSize: "12px",
              marginRight: "7px"
            }}
          ></i>

          <div>
            <div
              style={{
                fontSize: "9px",
                color: "#64748b",
                fontWeight: "600"
              }}
            >
              DEALER
            </div>

            <div
              style={{
                fontSize: "16px",
                fontWeight: "700",
                color: "#c2410c",
                lineHeight: "18px"
              }}
            >
              {Number(summary.GrandRemainsAtDealer || 0).toLocaleString("en-IN")}
            </div>
          </div>
        </div>
      </div>

      {/* Returned Warehouse */}
      <div className="col-lg-2 col-md-4 col-sm-6 mb-1">
        <div
          style={{
            height: "58px",
            padding: "6px 8px",
            borderRadius: "7px",
            background: "#f0fdfa",
            borderLeft: "3px solid #0d9488",
            display: "flex",
            alignItems: "center"
          }}
        >
          <i
            className="pi pi-replay"
            style={{
              color: "#0d9488",
              fontSize: "12px",
              marginRight: "7px"
            }}
          ></i>

          <div>
            <div
              style={{
                fontSize: "9px",
                color: "#64748b",
                fontWeight: "600"
              }}
            >
              WAREHOUSE RETURN
            </div>

            <div
              style={{
                fontSize: "16px",
                fontWeight: "700",
                color: "#0f766e",
                lineHeight: "18px"
              }}
            >
              {Number(summary.GrandReturnedToWarehouse || 0).toLocaleString("en-IN")}
            </div>
          </div>
        </div>
      </div>

      {/* Returned Dealer */}
      <div className="col-lg-2 col-md-4 col-sm-6 mb-1">
        <div
          style={{
            height: "58px",
            padding: "6px 8px",
            borderRadius: "7px",
            background: "#fef2f2",
            borderLeft: "3px solid #dc2626",
            display: "flex",
            alignItems: "center"
          }}
        >
          <i
            className="pi pi-refresh"
            style={{
              color: "#dc2626",
              fontSize: "12px",
              marginRight: "7px"
            }}
          ></i>

          <div>
            <div
              style={{
                fontSize: "9px",
                color: "#64748b",
                fontWeight: "600"
              }}
            >
              DEALER RETURN
            </div>

            <div
              style={{
                fontSize: "16px",
                fontWeight: "700",
                color: "#b91c1c",
                lineHeight: "18px"
              }}
            >
              {Number(summary.GrandReturnedByDealer || 0).toLocaleString("en-IN")}
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
)}
          <DataTable
            value={data}
            scrollable
            responsive={true}
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={PageSize}
            rowsPerPageOptions={[10, 20, 50, 100]}
            totalRecords={totalRecords}
            lazy={true}
            first={(PageNo - 1) * PageSize}
            onPage={this.onPage}
            onSort={this.onSort}
            sortField={this.state.SortColumn}
            sortOrder={this.state.SortOrder === "ASC" ? 1 : -1}
            emptyMessage="No data found."
          >
            <Column field="ProductName" header="Product Name" sortable />
            <Column field="GroupName" header="Group Name" sortable />
            <Column field="BatchNo" header="Batch No" sortable />
            <Column field="TotalReceived" header="Total Received" sortable />
            <Column field="TotalDispatched" header="Total Dispatched" sortable />
            <Column field="RemainsWithDistributor" header="Remains With Distributor" sortable />
            <Column field="RemainsAtDealer" header="Remains At Dealer" sortable />
            <Column field="ReturnedToWarehouse" header="Returned To Warehouse" sortable />
            <Column field="ReturnedByDealer" header="Returned By Dealer" sortable />
          </DataTable>
          {/* {summary && (
            <div className="mt-3">
              <h5>Summary</h5>
              <ul>
                <li>Grand Total Received: {summary.GrandTotalReceived}</li>
                <li>Grand Total Dispatched: {summary.GrandTotalDispatched}</li>
                <li>Grand Remains With Distributor: {summary.GrandRemainsWithDistributor}</li>
                <li>Grand Remains At Dealer: {summary.GrandRemainsAtDealer}</li>
                <li>Grand Returned To Warehouse: {summary.GrandReturnedToWarehouse}</li>
                <li>Grand Returned By Dealer: {summary.GrandReturnedByDealer}</li>
              </ul>
            </div>
          )} */}
        </div>
      </div>
    );
  }
}

export default DistributorReport;
